/**
 * Ключ localStorage для данных пользователя (Telegram).
 * Разделение по hostname предотвращает пересечение тестового и продового окружений.
 */
const LEGACY_KEY = "telegramUser";

function getTelegramUserStorageKey(): string {
  if (typeof window === "undefined") return LEGACY_KEY;
  return `telegramUser_${window.location.hostname}`;
}

export function getTelegramUserFromStorage(): string | null {
  const key = getTelegramUserStorageKey();
  let value = localStorage.getItem(key);
  // Миграция: если есть данные под старым ключом — переносим и удаляем старый
  if (!value && key !== LEGACY_KEY) {
    value = localStorage.getItem(LEGACY_KEY);
    if (value) {
      localStorage.setItem(key, value);
      localStorage.removeItem(LEGACY_KEY);
    }
  }
  return value;
}

export function setTelegramUserInStorage(data: string): void {
  localStorage.setItem(getTelegramUserStorageKey(), data);
}

export function removeTelegramUserFromStorage(): void {
  localStorage.removeItem(getTelegramUserStorageKey());
}
